import React from 'react';

const TermsConditions = ({ onBack }) => {
  return (
    <div className="min-h-screen bg-toon-yellow p-4">
      <div className="text-center mb-6">
        <img 
          src="/assets/Toon_House_Logo.svg" 
          alt="Toon House Logo" 
          className="h-24 mx-auto mb-2"
        />
      </div>
      <div className="container mx-auto px-4 py-8 max-w-4xl">
      <div className="bg-white shadow-lg rounded-lg p-6 md:p-8">
        <h1 className="text-3xl font-bold mb-6 text-center text-gray-800">Terms and Conditions</h1>
        
        <div className="prose max-w-none text-gray-700 prose-headings:text-gray-800 prose-strong:text-gray-800">
          <h2 className="text-xl font-semibold mt-6 mb-3">1. Acceptance of Terms</h2>
          <p>
            By accessing and using the Toon House platform, you agree to be bound by these Terms and Conditions. 
            If you do not agree to all the terms and conditions, you may not access or use the platform.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-3">2. Eligibility</h2>
          <p>
            You must be at least 13 years of age to use the Toon House platform. By using the platform, 
            you represent and warrant that you meet the eligibility requirements.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-3">3. Voting Rules</h2>
          <p>
            3.1. Users may vote for their preferred contestant during active voting periods.<br />
            3.2. Multiple votes from the same user may be subject to verification.<br />
            3.3. We reserve the right to disqualify votes that appear to be fraudulent or automated.<br />
            3.4. The final decision regarding contest winners rests solely with Toon House.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-3">4. User Conduct</h2>
          <p>
            4.1. You agree not to use the platform for any unlawful purpose or in violation of these Terms.<br />
            4.2. You agree not to attempt to interfere with the proper functioning of the platform.<br />
            4.3. You agree not to use automated means to access the platform or collect data from it.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-3">5. Intellectual Property</h2>
          <p>
            5.1. All content on the Toon House platform, including but not limited to text, graphics, logos, 
            and images, is the property of Toon House or its content suppliers and is protected by copyright laws.<br />
            5.2. You may not reproduce, distribute, display, or create derivative works from any content 
            on the platform without prior written permission.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-3">6. Limitation of Liability</h2>
          <p>
            6.1. Toon House shall not be liable for any indirect, incidental, special, consequential, or 
            punitive damages arising out of your use or inability to use the platform.<br />
            6.2. In no event shall our total liability exceed the amount you paid to us, if any, in the 
            preceding six months.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-3">7. Changes to Terms</h2>
          <p>
            We reserve the right to modify these Terms at any time. Your continued use of the platform 
            following any changes constitutes your acceptance of the revised Terms.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-3">8. Governing Law</h2>
          <p>
            These Terms shall be governed by and construed in accordance with the laws of the United States, 
            without regard to its conflict of law provisions.
          </p>
          
          <h2 className="text-xl font-semibold mt-6 mb-3">9. Contact Information</h2>
          <p>
            If you have any questions about these Terms, please contact us at support@toonhouse.com.
          </p>
        </div>
        
        <div className="mt-8 text-center">
          <button 
            onClick={onBack}
            className="bg-gray-800 text-white py-3 px-6 rounded-md font-semibold hover:bg-gray-900 transition-colors"
          >
            Back to Voting
          </button>
        </div>
      </div>
    </div>
    </div>
  );
};

export default TermsConditions;
